'use strict';

import angular from 'angular';
import ForgotPasswordController from './forgot-password.controller';

export default angular.module('conduuApp.forgotPassword', [])
  .controller('ForgotPasswordController', ForgotPasswordController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/forgot-password/index.js